import { render, staticRenderFns } from "./FCCNewPassword.vue?vue&type=template&id=2d4728a2"
import script from "./FCCNewPassword.vue?vue&type=script&lang=js"
export * from "./FCCNewPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports